export default __webpack_public_path__ + "static/helix-ps-4-a2218fd4c816d8a84fe495d0e26c7561.jpg";